import { useUser } from 'core/lite/hooks/useUser';
import { Avatar, Icon, InputCheckbox, TagsList, TextHtml } from 'ui';
import { DialogActivityPreview } from 'ui/shared';
import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import { stripHtml } from 'core/utils/utils';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import TooltipLearningObjectives from '../../lessons/components/TooltipLearningObjectives';

const ExerciseItem = ({
  t,
  selected,
  disabled,
  guid,
  name,
  onChangeSelected,
  image,
  description,
  authorGuid,
  isAutoevaluative,
  activity,
  selectJustOne,
  selectedItems,
  learningObjectives,
}) => {
  const { user } = useUser();
  const [openExercisePreview, setOpenExercisePreview] = useState(false);

  function onAddQuestion() {
    onChangeSelected(guid);
    setOpenExercisePreview(false);
  }

  return (
    <div className="exercise-item">
      <div className="exercise-item__container">
        <div className="exercise-item__left">
          <div className="exercise-item__check">
            {/* Hidden label gives the checkbox an accessible name; the visible name is HTML
                rendered separately, so we pass the plain-text name here. */}
            <InputCheckbox
              disabled={disabled || (!selected && selectJustOne && selectedItems.length >= 1)}
              checked={selected || disabled}
              label={<span className="sr-only">{stripHtml(name?.length > 0 ? name : description || activity.name)}</span>}
              onChange={() => onChangeSelected(guid)}
            />
          </div>
          <div className="exercise-item__image-container" style={{ backgroundImage: `url(${image})` }}>
            {isAutoevaluative === 1 && (
              <div className="exercise-item__icon-autoevaluative">
                <TooltipCustom title={t('lemonade:Autoevaluative activity')} placement={'top'} hasArrow={true}>
                  <span>
                    <Icon name="lightning" color="primary" size="sm" />
                  </span>
                </TooltipCustom>
              </div>
            )}
          </div>
          <div className="exercise-item__information">
            <div className="exercise-item__name">{<TextHtml text={name?.length > 0 ? name : description || activity.name} />}</div>
            <div className="exercise-item__author">{user.guid === authorGuid && <Avatar image={user.avatar} size="xs" />}</div>
            {learningObjectives && learningObjectives.length > 0 && (
              <div className="exercise-item__extra">
                <span className="exercise-item__extra-title">{t('common:Learning objectives')}:</span>
                <div className="lesson-item__tags">
                  <TagsList
                    tags={learningObjectives.map((item) => ({
                      //text: item.learning_objective.length > 40 ? item.learning_objective.substring(0, 40) + '(...)' : item.name,
                      text: item.learning_objective.substring(0, 40),
                      tooltip: <TooltipLearningObjectives tooltipText={item.description} tooltipTitle={item.learning_objective} />,
                    }))}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="exercise-item__right">
          <div className="exercise-item__preview-icon" onClick={() => setOpenExercisePreview(true)}>
            <Icon name="eye" />
          </div>
          <DialogActivityPreview
            open={openExercisePreview}
            activity={activity}
            onClose={() => setOpenExercisePreview(false)}
            title={' '}
            isAutoevaluative={isAutoevaluative === 1}
            onAddQuestion={onAddQuestion}
            questionGuid={guid}
            selected={selected}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

ExerciseItem.propTypes = {
  activity: PropTypes.object,
  authorGuid: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  guid: PropTypes.string,
  image: PropTypes.string,
  isAutoevaluative: PropTypes.number,
  learningObjectives: PropTypes.array,
  name: PropTypes.string,
  onChangeSelected: PropTypes.func,
  selected: PropTypes.bool,
  selectedItems: PropTypes.array,
  selectJustOne: PropTypes.bool,
  t: PropTypes.func,
};

ExerciseItem.defaultProps = {
  selected: false,
  disabled: false,
  onChangeSelected: () => {},
};

export default ExerciseItem;
